<template>
  <div
    class="calico-history"
    v-bind="$attrs"
  >
    <div
      v-if="type === 'business'"
      class="business"
    >
      <img
        v-if="img"
        :src="img"
      >
      <div class="info">
        <span class="name body--medium">{{ name }}</span>
        <span class="address body--xsmall">{{ address }}</span>
      </div>
    </div>
    <div
      v-else
      class="prompt"
      :title="prompt"
    >
      <span class="body--medium">{{ prompt }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoHistory",
  props: {
    type: {
      type: String,
      default: "",
    },
    img: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    prompt: {
      type: String,
      default: ''
    }
  },
};
</script>

<style lang="scss">
.calico-history {
  @include inline-space($space-small);
  @include inset-space($space-xxsmall);
  width: 100%;
  border-radius: $radius-small;
  cursor: default;
  user-select: none;
  .business {
    @include inline-space($space-small);
    .info {
      @include stack-space($space-none);
      .name {
        color: $color-text-primary;
      }
      .address {
        color: $color-text-secondary;
      }
    }
  }
  .prompt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $color-neutral-light;
    &:hover {
      color: $color-black;
    }
    &:active {
      color: $color-neutral-dark;
    }
  }

  &:hover {
    background: $color-neutral-lightest;
  }
  &:active {
    background: $color-transparent;
  }
}
</style>